// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorAiSettings = (client) => ({
    /**
     * `DELETE /vendor/ai-settings/openai-key`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteOpenAiKey
     * @source packages/medusa-plugin-ai-usage/src/api/vendor/ai-settings/openai-key/route.ts
     */
    deleteOpenaiKey: (body, query, headers) => client.fetch("/vendor/ai-settings/openai-key", { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/ai-settings/openai-key`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetOpenAiKeyStatus
     * @source packages/medusa-plugin-ai-usage/src/api/vendor/ai-settings/openai-key/route.ts
     */
    retrieveOpenaiKey: (query, headers) => client.fetch("/vendor/ai-settings/openai-key", { method: "GET", query, headers }),
    /**
     * `POST /vendor/ai-settings/openai-key`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSetOpenAiKey
     * @source packages/medusa-plugin-ai-usage/src/api/vendor/ai-settings/openai-key/route.ts
     */
    updateOpenaiKey: (body, query, headers) => client.fetch("/vendor/ai-settings/openai-key", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=ai-settings.js.map